import { Helmet } from "react-helmet";
import { useEffect } from "react";

const LINKS = [
  {
    label: "Notre site web",
    url: "https://www.startingfive.tg",
    logo: "/images/www.png",
    color: "#1a2756",
    bg: "#dbeafe",
  },
  {
    label: "Instagram",
    url: "https://www.instagram.com/startingfivetg/",
    logo: "/images/insta.png",
    color: "#78350f",
    bg: "#fdf6ec",
    logoSize: 42,
  },
  {
    label: "TikTok",
    url: "https://www.tiktok.com/@startingfivepoint",
    logo: "/images/tiktok.png",
    color: "#15803d",
    bg: "#dcfce7",
  },
];

export default function Links() {
  useEffect(() => {
  document.querySelector("header")?.style.setProperty("display", "none");
  document.querySelector("footer")?.style.setProperty("display", "none");
  return () => {
    document.querySelector("header")?.style.setProperty("display", "");
    document.querySelector("footer")?.style.setProperty("display", "");
  };
}, []);
  return (
    <div style={{
      minHeight: "100vh",
      background: "F5EAD3",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "40px 20px",
      fontFamily: "'DM Sans', system-ui, sans-serif",
    }}>

      {/* Pas d'indexation Google */}
      <Helmet>
        <title>Starting Five — Links</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {/* Logo S5L_B */}
      <div style={{ textAlign: "center", marginBottom: 40 }}>
        <img
          src="/images/S5L_B.png"
          alt="Starting Five"
          style={{
            width: 280,
            maxWidth: "80vw",
            objectFit: "contain",
          }}
        />
        <p style={{
          color: "#aaa",
          fontWeight: 600,
          marginTop: 16,
          fontSize: "0.95rem",
        }}>
          Retrouvez-nous partout 👇
        </p>
      </div>

      {/* Liens */}
      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: 16,
        width: "100%",
        maxWidth: 420,
      }}>
        {LINKS.map((link) => (
          <a
            key={link.label}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 16,
              background: link.bg,
              border: `3px solid #211B16`,
              borderRadius: 16,
              padding: "18px 24px",
              boxShadow: `5px 5px 0 #211B16`,
              textDecoration: "none",
              transition: "transform 0.1s, box-shadow 0.1s",
              cursor: "pointer",
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = "translate(-2px, -2px)";
              e.currentTarget.style.boxShadow = "7px 7px 0 #211B16";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = "none";
              e.currentTarget.style.boxShadow = "5px 5px 0 #211B16";
            }}
          >
            <div style={{
              width: 48, height: 48,
              background: "white",
              border: `2px solid #211B16`,
              borderRadius: 12,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "1.6rem",
              flexShrink: 0,
              boxShadow: `2px 2px 0 #211B16`,
            }}>
              <img
                src={link.logo}
                alt={link.label}
                style={{ width: link.logoSize || 32, height: link.logoSize || 32, objectFit: "contain" }}
              />
            </div>
            <span style={{
              fontFamily: "'Alfa Slab One', serif",
              fontSize: "1.1rem",
              color: link.color,
              letterSpacing: "0.01em",
            }}>
              {link.label}
            </span>
            <span style={{
              marginLeft: "auto",
              fontSize: "1.2rem",
              color: link.color,
            }}>→</span>
          </a>
        ))}
      </div>

      {/* Footer */}
      <p style={{
        marginTop: 40,
        color: "#473D34",
        fontSize: "0.8rem",
        fontWeight: 500,
        opacity: 0.6,
      }}>
        © 2026 Starting Five
      </p>

    </div>
  );
}